import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: null,
  addEncouragementGroupSuccess: false,
  encouragementGroupListData: {},
  createPostLoader: false,
  createPostModal: false,
  encouragementPostListData: [],
  encouragementPostListRenderData: [],
  createdPostData: {},
  topData: {},
  storeData: {},
  postCreatedSuccess: false,
  removeId: null,
  createPostSuccess: null,
  engagementGroupDeleteSuccess: null,
};
const encouragementgroupsSlice = createSlice({
  name: "encouragementgroups",
  initialState,
  reducers: {
    addEncouragementGroupLoad(state) {
      state.isLoading = true;
      state.addEncouragementGroupSuccess = false;
    },
    addEncouragementGroupSuccess(state, action) {
      state.isLoading = false;
      state.addEncouragementGroupSuccess = true;
    },
    addEncouragementGroupFail(state) {
      state.isLoading = false;
      state.addEncouragementGroupSuccess = false;
    },

    editEncouragementGroupLoad(state) {
      state.isLoading = true;
      state.addEncouragementGroupSuccess = false;
    },
    editEncouragementGroupSuccess(state, action) {
      state.isLoading = false;
      state.addEncouragementGroupSuccess = true;
    },

    addEncouragementGroupSuccessHandler(state, action) {
      state.addEncouragementGroupSuccess = !state.addEncouragementGroupSuccess;
    },

    editEncouragementGroupFail(state) {
      state.isLoading = false;
      state.addEncouragementGroupSuccess = false;
    },

    encouragementGroupListLoad(state) {
      state.isLoading = true;
    },
    encouragementGroupListSuccess(state, action) {
      state.isLoading = false;
      state.encouragementGroupListData = action.payload;
    },
    encouragementGroupListFail(state) {
      state.isLoading = false;
    },

    groupCreatePostLoad: (state) => {
      state.createPostLoader = true;
      state.postCreatedSuccess = false;
    },
    groupCreatePostSuccess: (state, action) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = true;
      state.createPostModal = false;
      state.encouragementPostListData = [];
      state.encouragementPostListRenderData = [];
      state.createdPostData = action.payload;
    },
    groupCreatePostFail: (state) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = false;
    },
    createGroupPostModalHandler: (state) => {
      state.createPostModal = !state.createPostModal;
      state.createPostSuccess = true;
    },



    /////  //////Dheeraj Code ////////////////////

    toxicGroupPostLoad: (state, action) => {
      state.createPostSuccess = false;
    },

    encouragementPostListLoad(state) {
      state.isLoading = true;
      state.encouragementPostListData = [];
    },
    encouragementPostListSuccess(state, action) {
      state.isLoading = false;
      state.encouragementPostListData = action.payload;
    },
    encouragementPostListFail(state) {
      state.isLoading = false;
      state.encouragementPostListData = [];
    },
    encouragementPostListEmpty(state) {
      state.encouragementPostListData = [];
      state.encouragementPostListRenderData = [];
      state.postCreatedSuccess = false;
    },
    encouragementRenderPostListLoad(state, action) {
      state.encouragementPostListRenderData = action?.payload;
    },

    removeIdLoad(state, action) { },

    commentPostSuccess(state, action) {
      console.log(action?.payload, "Payload");

      state.encouragementPostListRenderData =
        state.encouragementPostListRenderData.map((item) => {
          if (item._id === action.payload.post) {
            let updatedItem = { ...item };

            if (action.payload.typeOfComment === "reaction") {
              if (item.selfReaction) {
                if (item.selfReaction.comment === action.payload.comment) {
                  return updatedItem;
                }

                switch (item.selfReaction.comment) {
                  case "happyFace":
                    updatedItem.happyFace = Math.max(
                      (updatedItem.happyFace || 0) - 1,
                      0
                    );
                    break;
                  case "redHeart":
                    updatedItem.redHeart = Math.max(
                      (updatedItem.redHeart || 0) - 1,
                      0
                    );
                    break;
                  case "smileyHeart":
                    updatedItem.smileyHeart = Math.max(
                      (updatedItem.smileyHeart || 0) - 1,
                      0
                    );
                    break;
                  case "partyFace":
                    updatedItem.partyFace = Math.max(
                      (updatedItem.partyFace || 0) - 1,
                      0
                    );
                    break;
                  case "smileyFace":
                    updatedItem.smileyFace = Math.max(
                      (updatedItem.smileyFace || 0) - 1,
                      0
                    );
                    break;
                  default:
                    break;
                }
              }
              switch (action.payload.comment) {
                case "happyFace":
                  updatedItem.happyFace = (updatedItem.happyFace || 0) + 1;
                  break;
                case "redHeart":
                  updatedItem.redHeart = (updatedItem.redHeart || 0) + 1;
                  break;
                case "smileyHeart":
                  updatedItem.smileyHeart = (updatedItem.smileyHeart || 0) + 1;
                  break;
                case "partyFace":
                  updatedItem.partyFace = (updatedItem.partyFace || 0) + 1;
                  break;
                case "smileyFace":
                  updatedItem.smileyFace = (updatedItem.smileyFace || 0) + 1;
                  break;
                default:
                  break;
              }

              // Update selfReaction with the new reaction
              updatedItem.selfReaction = {
                _id: action.payload.id,
                comment: action.payload.comment,
                typeOfComment: "reaction",
                commentBy: action.payload.commentBy,
              };

              return updatedItem; // Return the updated item
            } else if (action.payload.typeOfComment === "comment") {
              // If typeOfComment is 'comment', increment the comment count
              return {
                ...updatedItem,
                comment: (updatedItem.comment || 0) + 1, // Increment comment count
              };
            }
          }

          return item; // Return the item as is if no updates are needed
        });

      console.log(state.encouragementPostListRenderData, "Updated List");
    },

    encouragementGetAllDataLoad(state, action) {
      state.isLoading = false;
    },
    encouragementGetAllDataSuccess(state, action) {
      state.isLoading = false;
      state.topData = action.payload;
    },
    encouragementGetAllDataFail(state, action) {
      state.isLoading = false;
    },
    /////////Dheeraj Code ////////////

    encouragementScoreLoad: (state) => {
      state.isLoading = true;
    },

    encouragmentScoreSuccess: (state, action) => {
      state.isLoading = false;
      state.storeData = action.payload;
    },


    engagementGroupDeleteLoad: (state) => {
      state.isLoading = true;
      state.engagementGroupDeleteSuccess = false;
    },
    engagementGroupDeleteSuccess: (state) => {
      state.isLoading = false;
      state.engagementGroupDeleteSuccess = true;
    },
    engagementGroupDeleteFailed: (state) => {
      state.isLoading = false;
    },


  },
});

export const {
  addEncouragementGroupLoad,
  addEncouragementGroupSuccess,
  addEncouragementGroupFail,
  addEncouragementGroupSuccessHandler,
  editEncouragementGroupLoad,
  editEncouragementGroupSuccess,
  editEncouragementGroupFail,
  encouragementScoreLoad,
  encouragmentScoreSuccess,

  removeIdLoad,

  toxicGroupPostLoad,

  commentPostSuccess,

  encouragementGroupListLoad,
  encouragementGroupListSuccess,
  encouragementGroupListFail,
  groupCreatePostLoad,
  groupCreatePostSuccess,
  groupCreatePostFail,
  createGroupPostModalHandler,
  encouragementPostListLoad,
  encouragementPostListSuccess,
  encouragementPostListFail,
  encouragementPostListEmpty,
  encouragementRenderPostListLoad,

  encouragementGetAllDataLoad,
  encouragementGetAllDataSuccess,
  encouragementGetAllDataFail,

  engagementGroupDeleteLoad,
  engagementGroupDeleteSuccess,
  engagementGroupDeleteFailed,

} = encouragementgroupsSlice.actions;

export default encouragementgroupsSlice.reducer;
